var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Part3"},[_c('div',{staticClass:"w"},[_c('div',{staticClass:"titleBlack"},[_c('div',[_vm._v("公司大事件")])]),_c('img',{attrs:{"src":require("@/assets/image/aboutus/part8@2x.png"),"alt":""}})])])
}]

export { render, staticRenderFns }